/**
 * Returns the denominator of the ratio of 1 to the given value as an integer.
 * @param value - The value to get the ratio of.
 * @returns The denominator of the ratio rounded to the nearest integer.
 *
 * @example
 * getRatioDenominator(0.25) // 4
 * getRatioDenominator(0.333) // 3
 * getRatioDenominator(0.5) // 2
 * getRatioDenominator(0.75) // 1
 * getRatioDenominator(1) // 1
 */
export function denominator(value: number): number {
    if (value <= 0 || value > 1) {
        throw new Error('Value must be positive and less than or equal to 1')
    }
    return Math.round(1 / value)
}
